import type { AssignedAssignmentsFilters } from '@repo/types/assignments';

import { FilterIcon } from 'lucide-react';

import AssignmentsFiltersContent from '@/components/features/assignments/header/AssignmentsFiltersContent';
import { Button } from '@/components/ui/button';
import { Drawer, DrawerBody, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from '@/components/ui/drawer';
import { SearchInput } from '@/components/ui/input';
import { filterLabels } from '@/lib/quiz';

interface AssignmentsHeaderProps {
  onSearchChange: (value?: string) => void;
  filterValue?: string;
  onFilterChange: (value?: AssignedAssignmentsFilters) => void;
}

export default function AssignmentsHeader(assignmentsHeaderProps: AssignmentsHeaderProps) {
  const { onSearchChange, filterValue, onFilterChange } = assignmentsHeaderProps;
  return (
    <div className={'border-border-primary bg-background flex w-full flex-col gap-3 rounded-2xl border p-4'}>
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex gap-3">
          <h2 className={'text-foreground text-xl font-semibold'}>Zadania</h2>

          <Drawer>
            <DrawerTrigger asChild>
              <Button variant={'outline'} className="ms-auto shrink-0 sm:hidden">
                <FilterIcon />
                {filterValue ? filterLabels[filterValue as AssignedAssignmentsFilters] : 'Filtry'}
              </Button>
            </DrawerTrigger>
            <DrawerContent>
              <DrawerBody>
                <DrawerHeader className="border-border-primary border-b">
                  <DrawerTitle>Filtry</DrawerTitle>
                </DrawerHeader>
                <DrawerDescription className={'sr-only'}>Filtry zadań</DrawerDescription>
                <div className="p-3 sm:p-4">
                  <AssignmentsFiltersContent value={filterValue} onValueChange={onFilterChange} />
                </div>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </div>
        <SearchInput className="w-full grow sm:ms-auto sm:max-w-64" setValue={onSearchChange} placeholder={'Szukaj...'} />
      </div>

      <AssignmentsFiltersContent value={filterValue} onValueChange={onFilterChange} className="hidden sm:flex" />
    </div>
  );
}
